module.exports = __webpack_public_path__ + "static/media/product-bg-4.cabb0a78.png";